import { mapState, mapActions } from 'vuex'

export default {
  name: 'FileSelectorButton',
  props: {
    name: {
      type: String,
      require: true
    },
    serviceId: {
      type: String,
      require: true
    },
    fileType: {
      // type: String,
      require: false,
      'default': () => ''
    },
    index: {
      type: Number,
      require: false,
      default: 0
    },
    model: {
      type: Object,
      require: false,
      'default': () => {}
    },
    disabled: {
      type: Boolean,
      require: false,
      'default': () => false
    }
  },
  computed: {
    ...mapState({
      buttonId: state => state.selectFileModal.buttonId,
      modalIndex: state => state.selectFileModal.index,
      value: state => state.selectFileModal.value
    }),

    fileName () {
      if (!this.model) return '選択されていません'
      return this.model.fileName
    },

    showDeleteButton () {
      if (!this.model) return false
      return this.model.fileName ? true : false
    }
  },
  watch: {
    value (to) {
      if (to &&
        this.buttonId === this.name &&
        this.index === this.modalIndex) {
        // console.log(this.name, to)
        this.changeFile(to)
      }
    }
  },
  methods: {
    ...mapActions({
      showSelectFileModal: 'selectFileModal/show',
    }),

    showFileSelector () {
      this.showSelectFileModal({
        serviceId: this.serviceId,
        buttonId: this.name,
        index: this.index,
        fileType: this.fileType
      })
    },

    changeFile (data) {
      this.$emit('childs-change', {
        name: this.name,
        index: this.index,
        data: data
      })
    },
    deleteFile () {
      this.$emit('childs-delete', {
        name: this.name,
        index: this.index
      })
    }
  }
}